import axios from 'axios';
// import { csrfTokenManager } from "@/csrf/CsrfTokenManager";

/**
 * Helper functions
 **/
export const a4d_axiosHelpers = {

    get(url) {
        return this.send_request({url: url, method: 'get'} );
    },

    post(url, data) {
      return this.send_request({url: url, method: 'post', data: data});
    },

    /**
     *
     * @param {Object} settings
     * @returns {*}
     */
    send_request(settings) {
        const {data_only = false, ...axiosSettings} = settings;
        return axios(axiosSettings)
            .then(response => {
                return data_only ? response.data : response;
            })
            .catch( error => {
                if (process.env.MIX_APP_ENV === 'production') {
                    throw error;
                }

                if (error.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                    console.log(error.response);
                } else if (error.request) {
                    // The request was made but no response was received
                    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                    // http.ClientRequest in node.js
                    console.log(error.request);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    console.log('Error', error.message);
                }

                // console.error('Error in Axios request:', error);
                // throw error for promise chaining
                throw error;
            });
    },

    // async update_csrf(csrf_token) {
    //     if (csrf_token) {
    //         await csrfTokenManager.updateFromResponse(csrf_token);
    //     }
    // },

    // updateFormCsrfToken(formElement, newToken) {
    //     if (formElement) {
    //         if (newToken) {
    //             const input = formElement.querySelector('input[name="_token"]');
    //             if (input) {
    //                 input.value = newToken;
    //             } else {
    //                 const hiddenInput = document.createElement('input');
    //                 hiddenInput.type = 'hidden';
    //                 hiddenInput.name = '_token';
    //                 hiddenInput.value = newToken;
    //                 formElement.appendChild(hiddenInput);
    //             }
    //         }
    //     }
    // }


}
